import { useEffect, useState } from "react";
import { API_OPTIONS } from "../utils/constants";

const useMovieTrailer = (movieId) => {
	const [trailerVideo, setTrailerVideo] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	// Fetch trailer video
	const getMovieVideos = async () => {
		if (!movieId) return;

		setLoading(true);
		setError(null);

		try {
			const data = await fetch(
				"https://api.themoviedb.org/3/movie/" +
					movieId +
					"/videos?language=en-US",
				API_OPTIONS
			);

			if (!data.ok) {
				throw new Error("Failed to fetch movie trailer");
			}

			const json = await data.json();
			const filterData = json.results.filter(
				(video) => video.type === "Trailer"
			);

			const trailer = filterData.length ? filterData[0] : json.results[0];
			setTrailerVideo(trailer);
		} catch (err) {
			setError(err.message);
			console.error("Error fetching movie trailer:", err);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (movieId) {
			getMovieVideos();
		}
	}, [movieId]);

	return { trailerVideo, loading, error };
};

export default useMovieTrailer;
